import type { ReactNode } from 'react';

export const symbol_blur_medium: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M280-280q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h177q-23.03-22.86-37.02-50.43Q406-418 402-450H210q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h191.79Q407-542 421-569.5t36-50.5H190q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h410q83 0 141.5 58.5T800-480q0 83-58.5 141.5T600-280H280Zm419-100.76q41-40.77 41-99Q740-538 699.24-579q-40.77-41-99-41Q542-620 501-579.24q-41 40.77-41 99Q460-422 500.76-381q40.77 41 99 41Q658-340 699-380.76ZM189.82-280q-12.82 0-21.32-8.68-8.5-8.67-8.5-21.5 0-12.82 8.68-21.32 8.67-8.5 21.5-8.5 12.82 0 21.32 8.68 8.5 8.67 8.5 21.5 0 12.82-8.68 21.32-8.67 8.5-21.5 8.5Z"
		/>
	</svg>
);
